import { render, staticRenderFns } from "./FolderLayer.vue?vue&type=template&id=534de956&"
import script from "./FolderLayer.vue?vue&type=script&lang=ts&"
export * from "./FolderLayer.vue?vue&type=script&lang=ts&"
import style0 from "./FolderLayer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports